import * as React from 'react';

import Loader from '../../components/Loader/Loader';
import UserAvatar from '../../components/UserAvatar/UserAvatar';
import * as avatar from '../../assets/image/manager.png';
import * as email from '../../assets/image/envelope.png';

import UserInfoResponse from '../../interfaces/UserInfoResponse';

import './style.scss';

interface Props {
  userId: number;
  userCountry: string;
  userLastName: string;
  userFirstName: string;
  isLoading: boolean;
  userInfo: UserInfoResponse;
  getUserAvatar: string;
  userEmail: string;
}

function ProfileInfo (props: Props) {

  return(
    <div className='profile-info-container'>
      <div className='d-flex justify-center align-center profile-wrapper'>
        <div className='avatar-container d-flex justify-center align-center'>
          {
            props.isLoading ?
              <Loader /> :
              (
            // tslint:disable-next-line:triple-equals
                props.userInfo.data[0].avatar != '' && props.userInfo.data.length > 0 ?
                  <UserAvatar
                    avatar={props.getUserAvatar} /> :
                  <UserAvatar
                    avatar={avatar} />
              )
          }
        </div>
        <div className='d-flex flex-column user-name'>
          {props.userFirstName || ''} {props.userLastName || ''}
          <div className='subtext mt-10'>{'Country :'} <span className='text-black'>{props.userCountry || ''}</span></div>
          <div className='subtext mt-10'>{'User ID :'} <span className='text-black'>{props.userId || ''}</span></div>
        </div>

      </div>
      <div className='profile-hr' />
      <footer className='profile-footer d-flex justify-center align-center'>
        <img
          className='email-icon'
          src={email} />
        <span className='profile-email'>{props.userEmail || ''}</span>
      </footer>

    </div>
  );
}

export default React.memo(ProfileInfo);
